<template>
  <div>
    <v-card max-height="700">
      <v-card-title class="cardheader">
        <span class="headline black--text">Exclude timespan</span>
        <exo-help-dialog
          :color="'black--text'"
          margin="m-0"
          title="Exclude timespan"
        >
          No maneuver will be carried out over the given date ranges. Timespans
          must be defined with a start date and an end date, both are needed to
          compute mission.
        </exo-help-dialog>
        <v-spacer></v-spacer>
        <v-btn icon light class="m-0" v-on:click="closeDialog()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="dialogSectionClass">
          <v-col>
            <v-row
              v-for="(timespan, index) in timespans"
              v-bind:key="index + timespan[0] + timespan[1]"
              ><v-col>
                <v-row>
                  <exoDatetimePicker
                    outlined
                    class="mt-3"
                    dense
                    :label="'Start date'"
                    v-model="timespan[0]"
                    :datePickerProps="datePickerProps"
                  />
                  <exoDatetimePicker
                    outlined
                    class="mt-3"
                    dense
                    :label="'End date'"
                    v-model="timespan[1]"
                    :datePickerProps="datePickerProps"
                  />
                  <v-btn icon class="m-0" v-on:click="deleteTimespan(index)">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-row>
                <v-row class="error--text" v-if="!timespanValid[index]">
                  Start date must be before end date
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-btn color="primary" @click="createTimespan()"
                >Add timespan constraint</v-btn
              ></v-row
            >
          </v-col>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '../../services/axios'

import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import exoDatetimePicker from '../../components/Forms/dateTimePicker.vue'
Vue.use(VueAxios, axios)
import moment from 'moment'

export default {
  name: 'TimespanEvasiveConstraints',

  mixins: [errorMixin],

  props: {
    isOpenDialog: Boolean,
    timespans: {
      type: Array,
      default: () => []
    },
    datePickerProps: {
      type: Object,
      default: {}
    }
  },

  components: {
    exoDatetimePicker
  },

  mounted() {},

  watch: {},

  data() {
    return {}
  },

  computed: {
    timespanValid() {
      return this.timespans.map((timespan) => {
        return (
          Array.isArray(timespan) &&
          timespan.length === 2 &&
          moment.utc(timespan[0]).isBefore(moment.utc(timespan[1]))
        )
      })
    }
  },

  methods: {
    createTimespan() {
      this.timespans.push(['', ''])
    },
    deleteTimespan(index) {
      this.timespans.splice(index, 1)
    },
    closeDialog() {
      this.$emit('update:isOpenDialog', false)
    }
  }
}
</script>

<style scoped>
.cardheader {
  background: #3be287;
}
.dialogSectionClass {
  margin-top: 4px;
}
</style>
